import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";

export default function Layout() {
  return (
    <div className="w-full min-h-screen bg-slate-50 flex text-slate-900 font-sans">
      <Sidebar />
      <main className="flex-1 min-w-0">
        <div className="max-w-[1600px] mx-auto w-full p-6 md:p-8 xl:p-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
